import {Field} from './field';
import {cr} from 'fire-wind-water';

class Desc extends Field {
  displaySelectType: string;
  displayType: number;

  constructor(field: unknown) {
    super(field);
    const attr = ['extraConfig'];
    cr.each(attr, d => {
      this[d] = field[d];
    });
    this.displaySelectType = 'DESC';
    this.displayType = 120;
    this.invalid = false;
  }

  setValue(): void {
  }

  initValue(): void {
  }

  clearValue(): void {

  }
}

export {Desc};
